const my_profile = {
  viewMyClubSeacretProfile: "Bekijk mijn ClubSeacret-profiel", // translated
  unverifiedEmail: "Niet-geverifieerde e-mail", // translated
  verifiedEmail: "Geverifieerde e-mail", // translated
  viewMoreDetails: "Bekijk meer details", // translated
  createdFrom: "Gemaakt vanaf", // translated
  createdTo: "Gemaakt tot", // translated
  selectStatus: "Selecteer status...", // translated
  searchByTitle: "Zoeken op titel...", // translated
  pushNotifications: "Push-meldingen",
  pushNotificationsDescription: "Browser-meldingen ontvangen voor belangrijke updates en gebeurtenissen",
  pushNotificationsNotSupported: "Push-meldingen worden niet ondersteund in deze browser",
  pushNotificationsDeniedMessage: "Meldingsmachtiging is geweigerd. Schakel meldingen in uw browserinstellingen in om push-meldingen te ontvangen.",
  pushNotificationsEnabled: "Push-meldingen succesvol ingeschakeld",
  pushNotificationsDisabled: "Push-meldingen succesvol uitgeschakeld",
  userInformationMissing: "Gebruikersinformatie ontbreekt",
  failedToUpdatePushNotifications: "Kan push-meldingsinstellingen niet bijwerken",
  notificationPermissionDenied: "Meldingsmachtiging is geweigerd. Schakel deze in uw browserinstellingen in.",
  notificationPermissionRequired: "Meldingsmachtiging is vereist om push-meldingen in te schakelen",
  notSupported: "Niet ondersteund",
  permissionDenied: "Machtiging geweigerd",
  permissionNotRequested: "Machtiging niet aangevraagd",
  enabled: "Ingeschakeld",
  disabled: "Uitgeschakeld",
};

export default my_profile;
